import React, { useContext } from 'react';
import SingleSlide from './singleSlide';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

import useVideoStyles from './styles';

function Video({ sectionData }) {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);

  const [videoData] = sectionData.components;
  const cardsCount = videoData?.videoCarousel?.components?.length;
  const slidesToShow = isMobile ? 1 : 2;
  const classes = useVideoStyles({
    containerWidth,
    cardsCount,
    slidesToShow,
    isMobile
  });

  const settings = {
    className: classes.sliderContainer,
    slidesToShow,
    centerPadding: isMobile ? '0px' : '100px 0 0',
    centerMode: true
  };

  const carouselContent = videoData.videoCarousel.components.map(
    (data, index) => <SingleSlide data={data} key={index} />
  );

  return (
    <div className={classes.videoSuperContainer}>
      <div className={classes.videoContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.videoHeading}>
            <span
              ref={videoData?.videoHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: videoData.videoHeading.metadata.value
              }}
            />
          </div>
          <h2 className={classes.videoTitle}>
            <span
              ref={videoData?.videoTitle?.refSetter}
              dangerouslySetInnerHTML={{
                __html: videoData.videoTitle.metadata.value
              }}
            />
          </h2>
          {cardsCount > slidesToShow ? (
            <Carousel hideArrow={isMobile} settings={settings}>
              {carouselContent}
            </Carousel>
          ) : (
            <div className={classes.contentRow}>{carouselContent}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Video;
